import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL + '/new_order/pro_retoucher/post';
const options = {
    headers: {
        'Content-Type': 'multipart/form-data',
    }
};
let needleUrl;
let newPayload;
function doneAdmin(params) {
    let neadleUrl = `${url}/done-admin`;
    let data = {};
    if (params.role) {
        neadleUrl += '/' + params.role;
    }
    if (params.final) {
        data.final = params.final;
    }
    if (params.auto_order_check) {
       data.auto_order_check = params.auto_order_check;
    }
    return axios.get(neadleUrl, {params: data})
        .then(response => {
            return {
                doneAdmin: response.data
            };
        });
}
function orderBroken(params) {
    let neadleUrl = `${url}/admin-broken-order`;
    let data = {};
    if (params.role) {
        data.role = params.role;
    }
    if (params.auto_order_check) {
        data.auto_order_check = params.auto_order_check;
    }

    return axios.get(neadleUrl, {params: data})
        .then(response => {
            return {
                orderBroken: response.data
            };
        });
}

function doneAdminForCustomer(params) {
    let needleUrl = `${url}/done-admin-for-customer`;
    let data = {};
    if (params.role) {
        needleUrl += '/' + params.role;
    }
    if (params.auto_order_check) {
        data.auto_order_check = params.auto_order_check;
    }
    return axios.get(needleUrl, {params: data})
        .then(response => {
            return {
                doneAdminForCustomer: response.data
            };
        });
}

function waitForDownloadPhoto(params) {
    let needleUrl = `${url}/wait-for-download-photo`;
    let data = {};
    if (params.role) {
        needleUrl += '/' + params.role;
    }
    if (params.auto_order_check) {
        data.auto_order_check = params.auto_order_check;
    }
    return axios.get(needleUrl, {params: data})
        .then(response => {
            return {
                waitForDownloadPhoto: response.data
            };
        });
}

function rejectedAdmin(payload) {
    let neadleUrl = `${url}/rejected-admin`;
    let newPayload = payload;
      if (Object.keys(payload).includes('role')) {
          neadleUrl += '/' + payload.role;
        newPayload = payload.data;
    } else {
        newPayload = payload;
    }
    return axios.post(neadleUrl, newPayload, options)
        .then(response => {
            return {
                rejectedAdmin: response.data
            };
        });
}

function writeRejected(payload) {
    needleUrl = `${url}/write-rejected`;
    if (Object.keys(payload).includes('role')) {
        needleUrl += '/' + payload.role;
        newPayload = payload.data;
    } else {
        newPayload = payload;
    }
    return axios.post(needleUrl, newPayload, options)
        .then(response => {
            return {
                writeRejected: response.data
            };
        });
}

function reDoneAdmin(payload) {
    needleUrl = `${url}/re-done-admin`;
    if (Object.keys(payload).includes('role')) {
        needleUrl += '/' + payload.role;
        newPayload = payload.data;
    } else {
        newPayload = payload;
    }
    return axios.post(needleUrl, newPayload, options)
        .then(response => {
            return {
                reDoneAdmin: response.data
            };
        });
}

function sendComment(payload) {
    needleUrl = `${url}/send-comment`;
    return axios.post(needleUrl, payload.data, options)
        .then(response => {
            return {
                sendComment: response.data
            };
        });
}

export default {
    doneAdmin,
    doneAdminForCustomer,
    rejectedAdmin,
    writeRejected,
    reDoneAdmin,
    orderBroken,
    sendComment,
    waitForDownloadPhoto
};